module.exports = __webpack_public_path__ + "static/media/center-align.ce25a219.svg";